/*eslint-env webextensions*/
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import queryString from 'query-string'

import {
  getState
} from './duck/operations'

import { device } from './lib/deviceSizes'
import { isRunningAsElectronApp } from './lib/environmentUtils'
import states from './lib/states'

import About from './components/about/'
import Player from './components/player/'
import GetTheApp from './components/getTheApp/'
import HowToCast from './components/howToCast/'
import MinimizedApp from './components/minimizedApp/'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;

  height: 100vh;
  width: 100vw;
  @media ${device.small} {
    min-height: 300px;
    max-height: 400px;
    min-width: 400px;
    max-width: 600px;
  }
  margin: 0 auto;

  font-family: ProximaNova-Regular;
`

class App extends Component {
  componentDidMount() {
    if (localStorage.getItem('first_visit') === undefined || localStorage.getItem('first_visit') === null) {
      localStorage.setItem('first_visit', false)
    }
    if (isRunningAsElectronApp()) {
      const { ipcRenderer } = window.require('electron')
      ipcRenderer.on('visibilitychange', () => {
        try {
          this.props.getState()
        } catch(error) {}
      })
    }
    document.addEventListener('visibilitychange', () => {
      if (document['hidden'] === false) {
        try {
          this.props.getState()
        } catch(error) {}
      }
    })
  }

  renderComponents = () => {
    if (this.props.minimized !== false) {
      return (
        <MinimizedApp />
      )
    }

    switch(this.props.status) {
    case states.AUTOSYNC:
    case states.BUFFERING:
    case states.PAUSED:
    case states.PLAYING:
      return <Player />

    case states.DISCONNECTED:
    case states.MISSING:
      if (isRunningAsElectronApp()) {
        // When running as Electron, the speaker is embedded, no need to display the GetTheApp page
        return <HowToCast />
      }
      return <GetTheApp />

    case states.STOPPED:
    case states.FAILED:
      return <HowToCast />

    default:
      return null
    }
  }

  render() {
    // TODO: use route instead of search parameters
    // This is because when packaged as en electron app, we're loading a bundled file (index.html) so we
    // cannot pass a route. We would need to eject from react-scripts to be able to have several bundled html files
    // generated by webpack.
    const location = queryString.parse(window.location.search)
    if (location.view && location.view === 'about') {
      return (
        <Root>
          <About />
        </Root>
      )
    }

    return (
      <Root>
        { this.renderComponents() }
      </Root>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.status,
    minimized: state.minimized
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getState
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js